/** @jsx jsx **/
import { jsx } from "@emotion/react";
import { navigate } from "gatsby";
import { useSetRecoilState } from "recoil";

import { modalToggleTermsOfServiceState } from "@recoil";
import { getPathWithToken } from "@func";

import * as styles from "./webviewfooter.style";

export default function WebViewFooter() {
  const setTermsOfServiceToggle = useSetRecoilState(
    modalToggleTermsOfServiceState
  );

  const handleClick = () => {
    navigate(getPathWithToken("?termsofservice=true"));
    setTermsOfServiceToggle(true);
  };

  return (
    <div css={styles.webViewFooter}>
      <p css={styles.companyName}>© 2012-2021 myrealtrip</p>
      <p css={styles.links} onClick={handleClick}>
        이용 약관 및 면책 조항
      </p>
    </div>
  );
}
